import $$ from 'cmn-utils';

export async function detail(payload) {
    return $$.get('/bad/get_host_detail', payload);
}
export async function bad_list(payload) {
    return $$.get('/bad/get_top_bad_list', payload);
}
export async function custom_list(payload) {
    return $$.get('/bad/get_custom_list', payload);
}